import { render, staticRenderFns } from "./RecruitManager.vue?vue&type=template&id=e8a78cb4"
import script from "./RecruitManager.vue?vue&type=script&lang=js"
export * from "./RecruitManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports